"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCompactEventOptions = getCompactEventOptions;

var _immutable = require("immutable");

var _get = _interopRequireDefault(require("transmute/get"));

var _ETypes = _interopRequireDefault(require("crm_universal/timeline/ETypes"));

var _ImmutableModel = require("customer-data-objects/model/ImmutableModel");

var _SidekickEventTypes = _interopRequireDefault(require("crm_schema/constants/SidekickEventTypes"));

var _UILink = _interopRequireDefault(require("UIComponents/link/UILink"));

var _react = _interopRequireDefault(require("react"));

var CompactEventOptions = (0, _immutable.Record)({
  bodyKey: '',
  bodyOptions: {}
}, 'CompactEventOptions');

function getCompactEventOptions(timelineItem, subject) {
  var etype = (0, _get.default)('etype', timelineItem);
  var eventData = (0, _get.default)('eventData', timelineItem);
  var displayName = (0, _ImmutableModel.toString)(subject);
  var compactEventConfig = CompactEventOptions({
    bodyKey: "profileContentTimeline." + etype + ".bodyText"
  });

  switch (etype) {
    case _ETypes.default.eventLifecycleStage:
      {
        var stage = (0, _get.default)('value', eventData);
        var source = (0, _get.default)('source-id', eventData);
        var sourceType = (0, _get.default)('source-type', eventData);
        return compactEventConfig.merge({
          bodyKey: compactEventConfig.bodyKey + "." + (source && sourceType === 'CRM_UI' ? stage ? 'withSource' : 'resetWithSource' : stage ? 'noSource' : 'reset'),
          bodyOptions: {
            contactName: displayName,
            source: source,
            stage: stage
          }
        });
      }

    case _ETypes.default.eventPrivacyConsent:
      return compactEventConfig.merge({
        bodyKey: compactEventConfig.bodyKey + "." + (0, _get.default)('activityType', eventData),
        bodyOptions: {
          contactName: displayName,
          consentUrl: (0, _get.default)('url', eventData)
        }
      });

    case _ETypes.default.eventSalesforceSync:
      return compactEventConfig.set('bodyOptions', {
        contactName: (0, _ImmutableModel.toString)(subject)
      });

    case _ETypes.default.eventSidekick:
      return compactEventConfig.merge({
        bodyKey: compactEventConfig.bodyKey + "." + _SidekickEventTypes.default[(0, _get.default)('type', eventData)],
        bodyOptions: {
          contactName: displayName,
          emailSubject: (0, _get.default)('object', eventData),
          emailLink: _react.default.createElement(_UILink.default, {
            external: true,
            href: (0, _get.default)('link', eventData)
          }, (0, _get.default)('link_title', eventData)),
          useReact: true
        }
      });

    case _ETypes.default.eventWebinarRegistration:
      return compactEventConfig.merge({
        bodyOptions: {
          contactName: displayName,
          webinarTitle: (0, _get.default)('webinarSubject', eventData),
          webinarUrl: (0, _get.default)('joinUrl', eventData)
        }
      });

    default:
      return compactEventConfig;
  }
}